import React from 'react';

import { Advantageous } from '@/ui/index';

const DiscountedRoamingCalls = ({ data }) => {
  return (
    <Advantageous
      advantageousData={data}
      itemScope
      itemType='http://schema.org/Offer'
    />
  );
};

export default DiscountedRoamingCalls;
